// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPatientRequest {
    static getAttributeTypeMap() {
        return MedicalBiPatientRequest.attributeTypeMap;
    }
}
MedicalBiPatientRequest.discriminator = undefined;
MedicalBiPatientRequest.additionalProperties = false;
MedicalBiPatientRequest.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "Date"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "MedicalBiGender"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPatientRequest.js.map